// GoalsAndContactStep5.js
import { Box } from "@mui/material";
import MainContentReUse from "./MainContentReUse";
import CheckboxesComponent from "./CheckboxesComponent";
import TextFieldWithHeading from "./TextFieldWithHeading";
import { useState } from "react";
import api from "../../config/axios";

const companyGoalsList = [
  { label: "Fundrasing" },
  { label: "Sales Growth" },
  { label: "Strategic Partners / GTM" },
  { label: "Brand Awareness" },
  { label: "User Growth" },
  { label: "Hiring" },
  { label: "Other" },
];

const professionalGoalsList = [
  { label: "Financial Freedom" },
  { label: "Relationships" },
  { label: "Health" },
  { label: "Meaning" },
  { label: "Peace of Mind" },
  { label: "Other" },
];

function GoalsAndContactStep5({ onFinish }) {
  // We'll keep track of the chosen checkboxes in arrays
  const [companyGoals, setCompanyGoals] = useState([]);
  const [professionalGoals, setProfessionalGoals] = useState([]);

  const [linkedin, setLinkedin] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [instagram, setInstagram] = useState("");

  const handleToggleCompanyGoal = (label) => {
    setCompanyGoals((prev) =>
      prev.includes(label) ? prev.filter((v) => v !== label) : [...prev, label]
    );
  };

  const handleToggleProfessionalGoal = (label) => {
    setProfessionalGoals((prev) =>
      prev.includes(label) ? prev.filter((v) => v !== label) : [...prev, label]
    );
  };

  // We'll call /api/auth/goals with this data
  const handleNext = async () => {
    try {
      await api.put("/auth/goals", {
        companyGoals,
        professionalGoals,
        linkedin,
        whatsapp,
        instagram,
      });

      // Once done, call parent to proceed or navigate
      onFinish(); 
    } catch (err) {
      console.error("Goals update error:", err);
      alert(err?.response?.data?.message || "Error updating goals");
    }
  };

  return (
    <MainContentReUse
      primaryButton={{ exist: true, text: "Complete Sign Up" }}
      onClick={handleNext}
      smallDivider={false}
      headLogoBelowPadding="0px"
    >
      <Box>
        <CheckboxesComponent
          primaryText="Company Goals (Optional)"
          secondaryText="Select your company goals"
          checkBoxes={companyGoalsList}
          value={companyGoals}
          onChange={handleToggleCompanyGoal}
        />
        <CheckboxesComponent
          primaryText="Professional Goals (Optional)"
          secondaryText="Select your personal goals"
          checkBoxes={professionalGoalsList}
          value={professionalGoals}
          onChange={handleToggleProfessionalGoal}
        />

        <TextFieldWithHeading
          heading="LinkedIn (Optional)"
          placeholder="http://www.linkedin.com/in/username"
          value={linkedin}
          onChange={(e) => setLinkedin(e.target.value)}
        />
        <TextFieldWithHeading
          heading="WhatsApp / SMS Number (Optional)"
          placeholder="Your phone number"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
        />
        <TextFieldWithHeading
          heading="Instagram or X Profile (Optional)"
          placeholder="http://www.instagram.com/username"
          value={instagram}
          onChange={(e) => setInstagram(e.target.value)}
        />
      </Box>
    </MainContentReUse>
  );
}

export default GoalsAndContactStep5;
